import { useSelector } from 'react-redux';
import { selectShowKycBanner } from 'session-selectors';
import UserDetailsView from './user_details_view';

const UserDetailsRedux = (props) => {
  const showKycBanner = useSelector(selectShowKycBanner);

  return <UserDetailsView {...props} showKycBanner={showKycBanner} />;
};

export default UserDetailsRedux;
